import React, {Component} from 'react'

import ZipAnswers from './ZipAnswers'
import ButtonAnswers from './ButtonAnswers'
import InputAnswers from './InputAnswers'
import RadioAnswers from './RadioAnswers'

import './styles.css'

const mapping = {
  button: ButtonAnswers,
  number: InputAnswers,
  radio: RadioAnswers,
  zip: ZipAnswers,
}

class Question extends Component {
  render() {
    const {question, answer, onChange} = this.props
    const {preamble, text, help, type} = question
    const AnswerComponent = mapping[type]
    return (
      <div className="question">
        {preamble &&
          <div className="question-preamble">
            {preamble}
          </div>
        }
        <div className="question-text">
          {text}
        </div>
        <div className="question-help">
          {help}
        </div>
        <div className="question-answers">
          {<AnswerComponent question={question} answer={answer} onChange={onChange} />}
        </div>
      </div>
    )
  }
}

export default Question



// WEBPACK FOOTER //
// ./src/components/Question/index.js